export const gtm1SocialPostCreator = {
  eventSocialPostCreatorActionHandler ({ data }) {
    const {
      screen_name,
      event_action,
      category_name,
      subcategory_name,
      way_of_adding,
      text_choice,
      background_choice,
      channel_name,
      were_hashtag_added,
      was_logo_added,
      was_background_changed,
      was_text_edited,
      edit_format,
      are_reviews_available,
      channel_package_name,
      source,
    } = data
    return {
      event: 'Social_Post_Creator_Action',
      properties: {
        screen_name,
        event_action,
        category_name,
        subcategory_name,
        text_choice,
        background_choice,
        way_of_adding,
        channel_name,
        were_hashtag_added,
        was_logo_added,
        was_background_changed,
        was_text_edited,
        edit_format,
        are_reviews_available,
        channel_package_name,
        source,
      },
    }
  },
}
